import React, { JSX, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './components/Router';
import './styles/main.scss';
import LogCannon from '@ace-clublabs/log-cannon';
import { TeamValue, WorkloadValue } from '@ace-clublabs/aws-tags';
import { Container, ThemeProvider } from '@ace-clublabs/shared-component-library';
import { AppState } from './components/MembershipAppState/MembershipAppStateProvider';
import { AppContainer } from './containers/AppContainer';

const App: () => JSX.Element = () => {
  let base_url = (global as any).public_url || '/';

  LogCannon.init('9SCaqyfl4dmanklz9bTzx5MNbhyCNb', {
    team: TeamValue.Membership,
    component: 'membership-new-join',
    workload: WorkloadValue.MembershipNewBusiness,
    runtimeVersion: navigator.userAgent,
  } as any);

  useEffect(() => {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });

    return () => {
      window.removeEventListener('pageshow', () => {});
    };
  }, []);

  return (
    <>
      <BrowserRouter basename={base_url}>
        <ThemeProvider>
          <AppState>
            <AppContainer>
              <Router />
            </AppContainer>
          </AppState>
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
